import { Button, Modal, Form, Row, Col, Input, Select, message } from "antd";
import { useEffect, useState } from "react";
import fetchAllSites from "../../../../services/fetchAllSites";
import fetchDataTrace from "../../../../services/fetchDataTrace";
import patchDataTrace from "../../../../services/patchDataTrace";
import { accessLevels } from "../../../../utils/data";
import { useQueryClient } from "@tanstack/react-query";

const { Option } = Select;

export default function UpdateUser({
  isVisible,
  selected,
  setUpdateModal,
  handleFetchUsers,
}: any) {
  const [isLoading, setLoading] = useState(false);
  const [roles, setRoles] = useState<any>([]);
  const [sites, setSites] = useState<any>([]);
  const [firms, setFirms] = useState<any>([]);
  const queryClient = useQueryClient();

  const [form] = Form.useForm();

  const onSubmit = async () => {
    const values = await form.getFieldsValue();
    const uri = `users/${selected?._id}`;
    const response = await patchDataTrace(values, uri);
    if (response.success) {
      message.success("Updated Successfully");
      handleFetchUsers();
      form.resetFields();
      hideModal();
      queryClient.invalidateQueries({ queryKey: ["users"] });
    } else {
      message.error(response.message);
    }
  };

  const hideModal = () => {
    setUpdateModal(false);
  };

  const handleFetchRoles = async () => {
    const uri = `roles`;
    const response = await fetchDataTrace({ uri });
    setRoles(response?.payload);
  };

  const handleFetchFirms = async () => {
    const uri = `firms`;
    const response = await fetchDataTrace({ uri });
    setFirms(response?.payload);
  };

  const handleFetchSites = async () => {
    const response = await fetchAllSites();
    setSites(response?.payload);
  };

  const siteOptions = sites.map((site: any, index: number) => (
    <Option value={site?._id} key={index}>
      {site?.name}
    </Option>
  ));

  const roleOptions = roles.map((role: any, index: number) => (
    <Option value={role?._id} key={index}>
      {role?.name}
    </Option>
  ));

  const accessOptions = accessLevels?.map((level: any, index: number) => (
    <Option value={level?.id} key={index}>
      Access Level {level?.id}
    </Option>
  ));

  const firmOptions = firms?.map((company: any, index: number) => (
    <Option value={company?._id} key={index}>
      {company?.name}
    </Option>
  ));

  useEffect(() => {
    form.resetFields();
    handleFetchSites();
    handleFetchRoles();
    handleFetchFirms();
  }, [selected]);

  return (
    <Modal
      visible={isVisible}
      title="Update User"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="udateUser"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="udateUser"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="firstname"
              label="Firstname"
              initialValue={selected?.firstname}
              rules={[
                {
                  required: true,
                  message: "Please enter Firstname",
                },
              ]}
            >
              <Input placeholder="First Name" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="lastname"
              label="Lastname"
              initialValue={selected?.lastname}
              rules={[
                {
                  required: true,
                  message: "Please enter Lastname",
                },
              ]}
            >
              <Input placeholder="Last Name" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="email"
              label="Email"
              initialValue={selected?.email}
              rules={[
                {
                  required: true,
                  message: "Please enter Email",
                },
              ]}
            >
              <Input
                type={"email"}
                placeholder="Email"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="kjlID"
              label="KJL ID"
              initialValue={selected?.kjlID}
              rules={[
                {
                  required: true,
                  message: "Please enter KJL ID",
                },
              ]}
            >
              <Input
                type={"text"}
                placeholder="KJL ID"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mobile"
              label="Mobile 1"
              initialValue={selected?.mobile}
              rules={[
                {
                  required: false,
                  message: "Please enter Mobile",
                },
              ]}
            >
              <Input placeholder="Mobile 1" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="mobile2"
              label="Mobile 2 ( Optional )"
              initialValue={selected?.mobile2}
              rules={[
                {
                  required: false,
                  message: "Please enter Mobile 2",
                },
              ]}
            >
              <Input placeholder="Mobile 2" style={{ width: "100%" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="site"
              label="Site"
              initialValue={selected?.site?._id}
              rules={[
                {
                  required: false,
                  message: "Please select office",
                },
              ]}
            >
              <Select defaultValue={selected?.site} placeholder="Office">
                {siteOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="firm"
              label="Company"
              initialValue={selected?.firm?._id}
              rules={[
                {
                  required: false,
                  message: "Please select company",
                },
              ]}
            >
              <Select defaultValue={selected?.firm?._id} placeholder="Company">
                {firmOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="role"
              label="Role"
              initialValue={selected?.role?._id}
              rules={[
                {
                  required: false,
                  message: "Please select role",
                },
              ]}
            >
              <Select defaultValue={selected?.role} placeholder="Role">
                {roleOptions}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="accessLevel"
              label="Access Level"
              initialValue={selected?.accessLevel}
              rules={[
                {
                  required: false,
                  message: "Please select access level",
                },
              ]}
            >
              <Select
                defaultValue={selected?.accessLevel}
                placeholder="Access Level"
              >
                {accessOptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="canUpload"
              label={"Upload Rights (on Academy )"}
              initialValue={selected?.canUpload}
              rules={[
                {
                  required: false,
                  message: "Please select upload status",
                },
              ]}
            >
              <Select
                defaultValue={selected?.canUpload}
                placeholder="Upload Rights"
              >
                <Option value={true}>Yes</Option>
                <Option value={false}>No</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 6 }}>
            <Form.Item
              name="isMessaged"
              label={"Booking SMS"}
              initialValue={selected?.isMessaged}
              rules={[
                {
                  required: false,
                  message: "Please select sms status",
                },
              ]}
            >
              <Select defaultValue={selected?.isMessaged} placeholder="SMS">
                <Option value={true}>Yes</Option>
                <Option value={false}>No</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 6 }}>
            <Form.Item
              name="isClaimer"
              label={"Claim Privilege"}
              initialValue={selected?.isClaimer}
              rules={[
                {
                  required: false,
                  message: "Please select claim status",
                },
              ]}
            >
              <Select defaultValue={selected?.isClaimer} placeholder="Claim">
                <Option value={true}>Yes</Option>
                <Option value={false}>No</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="isRoadside"
              label={"Roadside Access"}
              initialValue={selected?.canUpload}
              rules={[
                {
                  required: false,
                  message: "Please select one option",
                },
              ]}
            >
             <Select defaultValue={selected?.isRoadside} placeholder="Roadside">
                <Option value={true}>Yes</Option>
                <Option value={false}>No</Option>
              </Select>
            </Form.Item>
          </Col>
          </Row>
      </Form>
    </Modal>
  );
}
